import * as moment from 'moment'
// import LocalizationStore from '../Stores/LocalizationStore'

export default class DateTimeHelper {

    public static formatDateTimeForList(date: string): string {
        if (!date) {
            return ''
        }

        let tmp = moment(date).format('DD.MM.YYYY hh:mm')
        if ('Invalid date' === tmp) {
            tmp = moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY')
            if ('Invalid date' === tmp) {
                tmp = '' // LocalizationStore.getInstance().t('Invalid date')
            }
        }
        return tmp
    }

    public static formatDateForList(date: string): string {
        if (moment(date, 'DD.MM.YYYY', true).isValid()) {
            return date
        }

        if (!date) {
            return ''
        }

        let tmp = moment(date).format('DD.MM.YYYY')
        if ('Invalid date' === tmp) {
            tmp = moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY')
            if ('Invalid date' === tmp) {
                tmp = '' // LocalizationStore.getInstance().t('Invalid date')
            }
        }
        return tmp
    }

    public static parseFromListToMoment(date: string) {
        let tmp = moment.utc(date, 'DD.MM.YYYY')

        if ('Invalid date' === tmp.format()) {
            return null
        }

        return tmp
    }

    public static validateDate(date: string): boolean {
        let reg = /^[0-3]?[0-9].[0-3]?[0-9].(?:[0-9]{2})?[0-9]{2}$/g
        return !reg.test(date)
    }

    public static getFullYearsFromDate(date: string): number | null {
        if (!date || 'Invalid date' === moment(date).format('DD.MM.YYYY')) {
            return null
        }
        return moment().diff(date, 'years');
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/DateTimeHelper.ts